// import api from '../../api/openstack'
import api from '../../api/openstack'

export default {
  namespaced: true,

  state: {
    computes: [],
    computeSgroup: []
  },

  getters: {
    getComputes: (state) => {
      return state.computes
    },
    getComputeSgroup: (state) => {
      return state.computeSgroup
    },
    getComputeByID: (state) => (id) => {
      return state.computes[id]
    }
  },
  actions: {
    async getComputes ({state, getters, commit}, loading = 1) {
      if (loading === 1) commit('setLoadingState', true, {root: true})
      await api.computes.getComputes().then((computes) => {
        commit('setComputes', computes)
      })
      if (loading === 1) commit('setLoadingState', false, {root: true})
    },
    async shutdownCompute ({ commit }, id) {
      commit('setLoadingState', true, {root: true})
      await api.computes.shutdownCompute({ commit }, id)
      commit('setLoadingState', false, {root: true})
    },
    async deleteCompute ({ commit }, id) {
      commit('setLoadingState', true, {root: true})
      await api.computes.deleteCompute({ commit }, id)
      commit('setLoadingState', false, {root: true})
    },
    async startCompute ({ commit }, id) {
      commit('setLoadingState', true, {root: true})
      await api.computes.startCompute({ commit }, id)
      commit('setLoadingState', false, {root: true})
    },
    async createCompute ({ commit, dispatch }, data) {
      commit('setLoadingState', true, {root: true})
      await api.computes.createCompute({commit}, data)
      commit('setLoadingState', false, {root: true})
      dispatch('getComputes')
    },
    async getAttachedSecurityGroups ({ commit }, id) {
      await api.computes.getAttachedSecurityGroups({ commit }, id).then((groups) => {
        commit('setComputeSgroup', groups)
      })
    },
    async setSecurityGroupsToCompute ({ commit }, data) {
      await api.computes.setSecurityGroupsToCompute({ commit }, data.id, data.form)
    },
    async attachVolume ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.computes.attachVolume({commit}, data)
      commit('setLoadingState', false, {root: true})
    },
    async detachVolume ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.computes.detachVolume({commit}, data)
      commit('setLoadingState', false, {root: true})
    },
    async resize ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.computes.resize({commit}, data)
      commit('setLoadingState', false, {root: true})
    },
    async confirmResize ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.computes.confirmResize({commit}, data)
      commit('setLoadingState', false, {root: true})
    },
    async resetResize ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.computes.resetResize({commit}, data)
      commit('setLoadingState', false, {root: true})
    }
  },
  mutations: {
    setComputes (state, computes) {
      state.computes = computes
    },
    setComputeSgroup (state, group) {
      state.computeSgroup = group
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/computes.js